// Download filename for a worksheet PDF, set as the <Document title> — which is
// what the browser's PDF viewer uses as the suggested name on download.
// Format: {Audience}.{Lease|Finance}.{Model}.{Trim}.{MM-DD-YYYY}
//   e.g. Dealer.Lease.Accord.EX-L.06-26-2026
export const buildPdfFileName = (dealState, audience) => {
    const car  = dealState?.car_detail || {}
    const type = dealState?.is_purchase ? 'Finance' : 'Lease'

    const today = new Date()
    const date = [
        String(today.getMonth() + 1).padStart(2, '0'),
        String(today.getDate()).padStart(2, '0'),
        today.getFullYear(),
    ].join('-')

    // Strip dots/spaces from each part so they don't collide with the dot
    // separators (keeps hyphens, e.g. "EX-L").
    const clean = (v) => String(v ?? '').replace(/\./g, '').replace(/\s+/g, '').trim()

    return [audience, type, clean(car.model), clean(car.trim), date]
        .filter(Boolean)
        .join('.')
}
